import { Typo } from "../../Typo";

// Flags a recently-added rebate program / Sub IB. Brand-blue so it reads as
// a freshness marker distinct from the amber/neutral status pills.
export const NewTag = () => (
  <span
    className="inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-full bg-surface-accent-blue-subtler px-1"
    aria-label="Recently added"
  >
    <Typo
      element="span"
      type="label2XS"
      textColor="text-text-accent-blue-boldest"
      className="whitespace-nowrap px-0.5"
    >
      New
    </Typo>
  </span>
);
